export default __webpack_public_path__ + "static/media/certification-test-result-header-bg.8f28289d.png";